import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var HeartSVG = function HeartSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27 5.6a7.91 7.91 0 00-10.49.87l-.51.47-.46-.47A7.91 7.91 0 005.05 5.6a8 8 0 00-.76 11.92l.65.66L15.29 28.7a1 1 0 001.42 0l10.35-10.52.65-.66A8 8 0 0027 5.6z"
  }));
};
HeartSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HeartSVG);